module.exports = __webpack_public_path__ + "static/img/shiLi-2.4a693e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shiLi-2.png
// module id = J5JZ
// module chunks = 1